import Icon from '../Icon.vue'

Icon.register({
  'child_friendly': {
    width: 10,
    height: 12,
    paths: [
      {
        d: 'M9.257 2.37a1.69 1.69 0 00-1.9-.341 2.532 2.532 0 00-4.964 0 1.69 1.69 0 00-1.9 2.727l1.382 1.38v4.176c0 .931.757 1.688 1.688 1.688h.187a1.68 1.68 0 001.125-.43c.299.267.693.43 1.125.43h.188a1.69 1.69 0 001.687-1.688V6.136l1.382-1.38a1.69 1.69 0 000-2.387zM4.875 1.124a1.406 1.406 0 110 2.813 1.406 1.406 0 010-2.813zM8.46 3.96L6.75 5.67v4.643c0 .31-.252.562-.562.562H6a.562.562 0 01-.562-.563v-2.25H4.313v2.25c0 .311-.252.563-.563.563h-.187A.562.562 0 013 10.312V5.67L1.29 3.96a.563.563 0 01.795-.795l1.71 1.71h2.16l1.71-1.71a.563.563 0 01.795.795z'
      }
    ]
  }
})
